export const databaseDateFormat = 'YYYY-MM-DD';
